/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesRegistrationStatusSchema = z.enum([
  "Pending",
  "Approved",
  "Rejected",
  "Cancelled",
]);
